var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProtocolIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-129 -948)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2px",
    d: "M-5941.393,6636v4",
    transform: "translate(6071.393 -5688)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2px",
    d: "M-5941.393,6636v4",
    transform: "translate(-6507 -4992.393) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2px",
    d: "M-5941.393,6636v4",
    transform: "translate(6091.393 -5688)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2px",
    d: "M0,4V0",
    transform: "translate(147 949) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2px",
    d: "M-5941.393,6636v4",
    transform: "translate(-6507 -4972.393) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2px",
    d: "M-5941.393,6636v4",
    transform: "translate(-5811.393 7606) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2px",
    d: "M0,4V0",
    transform: "translate(147 969) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2px",
    d: "M0,4V0",
    transform: "translate(150 966)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2px",
    d: "M-5941.393,6636v4",
    transform: "translate(-6501 -4992.393) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2px",
    d: "M-5941.393,6636v4",
    transform: "translate(-6501 -4972.393) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2px",
    d: "M-5941.393,6636v4",
    transform: "translate(-5811.393 7600) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2px",
    d: "M-5941.393,6636v4",
    transform: "translate(-5791.393 7600) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2px",
    d: "M-5941.393,6636v4",
    transform: "translate(-6495 -4992.393) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2px",
    d: "M-5941.393,6636v4",
    transform: "translate(-6495 -4972.393) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2px",
    d: "M-5941.393,6636v4",
    transform: "translate(-5811.393 7594) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2px",
    d: "M-5941.393,6636v4",
    transform: "translate(-5791.393 7594) rotate(180)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtocolIcon);
export default __webpack_public_path__ + "static/media/protocol-icon.90faff65.svg";
export { ForwardRef as ReactComponent };